<template>
  <div class="abstract-text">
    <div
      class="border-softened border-bottom border-normal mt-2 pb-3 mb-1 mr-2"
    >
      <h2 class="title">Abstract</h2>
    </div>
    <Abstract :abstract="article.abstract" body mr-2 mt-3 />

    <CiteButton
      v-if="!newArticleDetailsDisplay"
      :article="article"
      :citation-style="citationStyle"
    />
  </div>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

import Abstract from "~/components/articles/components/Abstract";
import CiteButton from "~/components/articles/components/CiteButton";

export default {
  name: "AbstractText",
  components: {
    Abstract,
    CiteButton,
  },
  props: {
    article: { type: Object, required: true },
    citationStyle: { type: Object, default: undefined },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
};
</script>
